import { inject, observer } from 'mobx-react';
import React from 'react'
import { ReactComponent as CheckLeft } from '../../../svg/chevron-left.svg'
import { ReactComponent as SetBgIcon } from '../../../svg/set-background.svg'
import { ReactComponent as TrashIcon } from '../../../svg/trash-alt.svg'
import Upload from '../../Inputs/Upload';
import ScrollArrow from '../../Inputs/ScrollArrow';

@inject('photoStore', 'store', 'sidebarStore', 'workAreaStore') @observer
class PhotoSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      apiScroll: 0,
      userScroll: 0,
      teamAssetScroll: 0,
      brandScroll: 0,
      uploading: false
    }
  }

  componentDidMount(){
    const { photoStore, store } = this.props
    if(photoStore.photoItems.col_1.length === 0){
      photoStore.searchImages(true)
    }
    if(!photoStore.userAssetsFetched && store.auth){
      photoStore.fetchUserImages(false)
    }
    if(!photoStore.userAssetsFetched && store.auth && this.props.workAreaStore.activeBrand){
      photoStore.fetchUserImages(this.props.workAreaStore.activeBrand)
    }
    if(!store.auth){
      photoStore.setFetchStatus(true)
    }
    if(store.isTeam){
      photoStore.fetchTeamAssets()
    }
  }

  componentDidUpdate(prev){
    const { activeBrand: latestBrandProps } = this.props.workAreaStore
    if(!this.props.uploadsOnly && latestBrandProps && prev.activeBrand !== this.props.workAreaStore.activeBrand){
      this.props.photoStore.fetchUserImages(this.props.workAreaStore.activeBrand, true)
    }
  }

  async deletePhoto(e, item){
    e.preventDefault()
    if(item && item.assetId){
      try{
        await this.props.photoStore.deleteAsset(item.assetId)
      }catch(err){
        console.log(err)
      }
    }
  }

  setBackground(e, item, isUpload){
    e.preventDefault()
    this.toggleFull()
    const { workAreaStore } = this.props
    let url = isUpload ? item.url : item.urls.regular
    if(workAreaStore.activePage){
      item.isUpload = isUpload
      workAreaStore.changePageProp(workAreaStore.activePage, 'backgroundUrl', url, item)
    }else{
      workAreaStore.pages.forEach(p => {
        workAreaStore.changePageProp(p.id, 'backgroundUrl', url, item)
      })
    }
  }

  getPhotoContent(item, idx, col, isProject, vertical, isTeam) {
    const { sidebarStore } = this.props
    if(!item){
      return <div />
    }
    const isUpload = item.isUpload
    return (
      <div
      key={item.id + idx} className={`sidebar-slide__photo ${vertical ? 'vertical' : ''}`} 
      onClick={col ? e => this.handleClick(e, item) : (e) => this.handleClickUpload(e, item)}
      onMouseDown={e => sidebarStore.setSelectedItem({...item, type: 'photo', isUpload}, 'photo', e)}
      draggable
      onDrop={() => false}
      >
        <div className='sidebar-slide__photo__upload-options'>
          <SetBgIcon 
            className='set-bg-icon'
            onClick={e => this.setBackground(e, item, isUpload)}
          />
          {
            isUpload ? (
              <TrashIcon 
                className='trash-icon' 
                onClick={e => this.deletePhoto(e, item)} 
              />
            )
            :
            undefined
          }
        </div>
        <img
          className={vertical ? 'photos__photo-previews__vertical-item' : "sidebar-slide__photo__preview"}
          src={col ? item.urls.small : item.thumbURL ? item.thumbURL : item.url} 
          alt={col ? item.alt_description : ''}
          style={{
            display: item.loading ? 'none' : 'initial' 
          }}
          draggable="false"
          onLoad={col ? () => this.props.photoStore.setImageLoading(item.id, col) : () => this.props.photoStore.setImageLoading(item.assetId, null, isProject, isTeam)}
          onError={!col ? () => this.props.photoStore.handleLoadError(item.assetId, isProject, isTeam) : undefined}
          onDrop={() => false}
        />
        {
        item.loading ? (
          <span className='sidebar-slide__photo__loading'>
            <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
          </span>
        )
        :
        undefined
        }
      </div>
    )
  }

  toggleFull(){
    if(this.props.sidebarStore.fullScreen){
      this.props.sidebarStore.toggleFullscreen()
      this.props.workAreaStore.setHidden(false)
    }
  }

  handleClick(e, photo){
    this.toggleFull()
    const node = e.target.nodeName
    if(node === 'svg' || node === 'path'){
      return
    }
    if(photo.loading){
      return
    }
    setTimeout(() => {
      this.props.workAreaStore.insertPhotoToPage(photo, false)
    }, 0);
  }

  handleClickUpload(e, item){
    const node = e.target.nodeName
    if(node === 'svg' || node === 'path'){
      return
    }
    if(item.loading){
      return
    }
    const { naturalWidth, naturalHeight } = e.target
    const photo = {
      height: naturalHeight,
      width: naturalWidth,
      urls: {
        regular: item.url
      },
      isUpload: true,
      assetId: item.assetId
    }
    if(item.parsedSVG){
      photo.parsedSVG = item.parsedSVG
      photo.assetColors = item.assetColors
      photo.rawSVG = item.rawSVG
    }
    this.handleClick(e, photo)
  }

  setDisplay(type){
    this.props.sidebarStore.setObjectsView(type)
    const s = document.querySelector('.sidebar-slide.photos')
    if(s){
      s.scrollTo(0, 10)
    }
    this.props.photoStore.initProgress()
  }

  unsetSingleView(){
    this.props.sidebarStore.unsetObjectsView()
    this.props.photoStore.initProgress()
  }

  getImg(item, url, col, isProject, isUpload){
    return (
      <div
        key={item.assetId ? item.id + item.assetId : item.id}
        className='photos-col__img-wrapper'
        onClick={col ? e => this.handleClick(e, item) : (e) => this.handleClickUpload(e, item)}
        onDrop={() => false}
      >
        <div 
          className="photos-col__img-options"
        >
            <SetBgIcon 
              className='set-bg-icon'
              onClick={e => this.setBackground(e, item, isUpload)}
            />
            {
              isUpload ? (
                <TrashIcon 
                  className='trash-icon' 
                  onClick={e => this.deletePhoto(e, item)} 
                />
              )
              :
              undefined
            }
        </div>
        <img
          src={url} 
          style={{
            display: item.loading ? 'none' : 'initial' 
          }}
          onMouseDown={e => this.props.sidebarStore.setSelectedItem({...item, type: 'photo', isUpload}, 'photo', e)}
          draggable
          onLoad={col ? () => this.props.photoStore.setImageLoading(item.id, col) : () => this.props.photoStore.setImageLoading(item.assetId, null, isProject)}
          onError={!col ? () => this.props.photoStore.handleLoadError(item.assetId, isProject) : undefined}
          onDrop={() => false}
        />
        {
        item.loading ? (
          <span className='photos-col__loading'>
            <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
          </span>
        )
        :
        undefined
        }
    </div>
    )
  }

  getFullImageView(title, display, userContent = false, projectContent = false, teamContent = false, fullscreen = false, hideback = false){
    const { photoItems: { col_1, col_2 }, userAssets, projectAssets, teamAssets, apiLoaded } = this.props.photoStore
    let elems = <div />
    if(!display){
      return <div />
    }
    if(teamContent){
      elems = teamAssets.map((asset, idx) => (
        this.getImg(asset, asset.thumbURL ? asset.thumbURL : asset.url, null, false, true)
      ))
    }
    if(projectContent){
      elems = projectAssets.map((asset, idx) => (
        this.getImg(asset, asset.thumbURL ? asset.thumbURL : asset.url, null, false, true)
      ))
    }
    if(userContent){
      elems = userAssets.map((asset, idx) => (
        this.getImg(asset, asset.thumbURL ? asset.thumbURL : asset.url, null, false, true)
      ))
    }
    if(!userContent && !projectContent && !teamContent){
      elems = [...col_1, ...col_2].map((asset, idx) => (
        this.getImg(asset, asset.urls.small, asset.col, false, false)
      ))
    }
    return (
      <div className={`photos-col ${fullscreen ? 'full-screen' : ''}`}>
        {
          hideback ? undefined : (
            <h5 className='photos-col__menu-actions' 
              onClick={() => hideback ? undefined : this.unsetSingleView()}>
              {hideback ? undefined : <CheckLeft />}
              {hideback ? undefined : title}
            </h5>
          )
        }
        <div className='photos-col__vertical'>
          {elems}
        </div>
      </div>
    )
  }

  async handleScrollLoad(type){
    const { apiLoading, userAssetsLoading, projectAssetsLoading, teamAssetsLoading } = this.props.photoStore
    switch(type){
      case 'apiScroll':
        if(!apiLoading){
          this.props.photoStore.increasePage()
          this.props.photoStore.searchImages()
        }
        break
      case 'userScroll':
        if(!userAssetsLoading){
          this.props.photoStore.fetchUserImages()
        }
        break
      case 'brandScroll':
        if(!projectAssetsLoading){
          this.props.photoStore.fetchUserImages(true)
        }
        break
      case 'teamAssetScroll':
        if(!teamAssetsLoading){
          this.props.photoStore.fetchTeamAssets()
        }
        break
      default:
        break
    }
  }

  setScrollPos(obj, e, user = false, brand = false){
    let elClass = '.photos__photo-previews'
    if(user){
      elClass = '.photos__photo-previews.user-uploads'
    }
    if(brand){
      elClass = '.photos__photo-previews.brand-photos'
    }
    this.setState({[obj]: e.target.scrollLeft})
    const el = document.querySelector(elClass)
    const parent = document.querySelector('.slide-wrapper')
    const w = el.scrollWidth
    const pos = el.scrollLeft + parent.clientWidth
    if(w - pos < 200){
      this.handleScrollLoad(obj)
    }
  }

  async uploadToServer(file){
    this.setState({ uploading: true })
    await this.props.photoStore.uploadImage(file, this.props.workAreaStore.designId)
    this.setState({ uploading: false })
    return true
  }

  render(){
    const { 
      photoItems, 
      teamAssets,
      apiLoaded, 
      userAssetsFetched, 
      projectAssets, 
      projectAssetsFetched, 
      userAssets, 
      userAssetsLoading, 
      projectAssetsLoading, 
      isEmpty, 
      projectEmpty, 
      teamAssetsFetched,
      progress 
    } = this.props.photoStore
    const { apiPhotosOnly, userPhotosOnly, projectAssetsOnly, teamAssetsOnly, fullScreen } = this.props.sidebarStore
    const { activeBrand } = this.props.workAreaStore
    const { uploadsOnly } = this.props
    const { uploading } = this.state
    const { isTeam, teamDetails } = this.props.store
    const isSingle = apiPhotosOnly || userPhotosOnly || projectAssetsOnly || teamAssetsOnly
    return (
      <div 
        className="slide-wrapper"
        style={{
          paddingBottom: fullScreen ? '' : '20px'
        }}
      >
        <div className={`photos ${fullScreen ? 'full-screen' : 'limited-size'}`} style={{paddingBottom: '10%'}}>
          {
            isSingle ? undefined :
            (
              <div className='photo-upload' style={fullScreen ? { maxWidth: '400px', margin: '0 auto' } : {}}>
                <Upload 
                  name='image' 
                  label={'Drag your photo here or click here and browse from your computer'}  admin

                  customStyle={{
                    width: '95%',
                    margin: '2.5%',
                    marginTop: uploadsOnly ? '10px' : '0'
                  }}
                  uploading={uploading}
                  progress={progress}
                  upload={this.uploadToServer.bind(this)}
                />
              </div>
            )
          }
          {
            userPhotosOnly || uploadsOnly || projectAssetsOnly || teamAssetsOnly ? undefined :
            (
              apiPhotosOnly ? 
              (
                this.getFullImageView('Photos', isSingle, false, false, false, fullScreen)
              )
              :
              (
                <>
                  <div className={`photos__title-wrapper`}>
                    <h5 className='photos__title no-select'>
                      Photos
                      <span className='photos__title__view-all' onClick={() => this.setDisplay('api-photos')}>View all</span>
                    </h5>
                    <ScrollArrow
                      loading={this.props.photoStore.apiLoading}
                      style={{
                        top: '188px'
                      }}
                      scrollPosition={this.state.apiScroll}
                      scrollClass={'api-photos'}
                      parentClass={'slide-wrapper'}
                    />
                  </div>
                  {
                    photoItems.col_1.length && photoItems.col_2.length ? (
                      <div className='photos__photo-previews api-photos' onScroll={e => this.setScrollPos('apiScroll', e)}>
                        <div className='photos__row'>
                          {
                            photoItems.col_1.map((p, idx) => (
                              this.getPhotoContent(p, idx, 'col_1', false, false)
                            ))
                          }
                        </div>
                        <div className='photos__row'>
                          {
                            photoItems.col_2.map((p, idx) => (
                              this.getPhotoContent(p, idx, 'col_2', false, false)
                            ))
                          }
                        </div>
                      </div>
                    )
                    :
                    (
                      <div className='photos__empty'>
                        {
                          apiLoaded ? (
                            <>
                              <span>No photos</span>
                              <label className='gray'>Try searching for something else</label>
                            </>
                          )
                          :
                          (
                            <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                          )
                        }
                      </div>
                    )
                  }
                </>
              )
            )
          }
          {
            userPhotosOnly || uploadsOnly || projectAssetsOnly || !isTeam || !teamDetails._id ? undefined :
            (
              teamAssetsOnly ? 
              (
                this.getFullImageView('Team assets', isSingle, false, false, true, fullScreen)
              )
              :
              (
                <>
                  <div className={`photos__title-wrapper`}>
                    <h5 className='photos__title no-select'>
                      Team assets
                      <span className='photos__title__view-all' onClick={() => this.setDisplay('team-assets')}>View all</span>
                    </h5>
                    <ScrollArrow
                      loading={this.props.photoStore.teamAssetsLoading}
                      scrollPosition={this.state.teamAssetScroll}
                      scrollClass={'team-assets'}
                      parentClass={'slide-wrapper'}
                    />
                  </div>
                  {
                    teamAssets.length ? (
                      <div 
                        className='photos__photo-previews team-assets'
                        style={{
                          height: '200px',
                          marginBottom: ''
                        }}
                        onScroll={e => this.setScrollPos('teamAssetScroll', e)}
                      >
                        <div className='photos__row'>
                          {
                            teamAssets.map((p, idx) => (
                              this.getPhotoContent(p, idx + '_team', null, false, false, true)
                            ))
                          }
                        </div>
                      </div>
                    )
                    :
                    (
                      <div className='photos__empty'>
                        {
                          teamAssetsFetched ? (
                            <>
                              <span>No team assets</span>
                              <label className='gray'>{`Go ahead and upload an image`}</label>
                            </>
                          )
                          :
                          (
                            <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                          )
                        }
                      </div>
                    )
                  }
                </>
              )
            )
          }
          {
            !activeBrand || apiPhotosOnly || uploadsOnly || userPhotosOnly || teamAssetsOnly ? undefined :
            (
              projectAssetsOnly ? (
                this.getFullImageView('Brand assets', isSingle, false, true, false, fullScreen)
              )
              :
              (
                <>
                <div className='photos__title-wrapper'>
                  <h5 className='photos__title no-select'>
                    Brand assets
                    <span className='photos__title__view-all' onClick={() => this.setDisplay('brand-assets')}>View all</span>
                  </h5>
                  <ScrollArrow
                    loading={this.props.photoStore.projectAssetsLoading}
                    scrollPosition={this.state.brandScroll}
                    scrollClass={'brand-photos'}
                    parentClass={'slide-wrapper'}
                  />
                </div>
                {
                  projectAssets.length ? (
                    <div 
                      className='photos__photo-previews brand-photos'
                      style={{
                        height: '200px',
                        marginBottom: ''
                      }}
                      onScroll={e => this.setScrollPos('brandScroll', e, false, true)}
                    >
                      <div className='photos__row'>
                        {
                          projectAssets.map((p, idx) => (
                            this.getPhotoContent(p, idx, null, true, false)
                          ))
                        }
                      </div>
                    </div>
                  )
                  :
                  (
                    <div className='photos__empty'>
                      {
                        projectAssetsFetched ? (
                          <>
                            <span>No brand assets</span>
                            <label className='gray'>{`Go ahead and upload an image`}</label>
                          </>
                        )
                        :
                        (
                          <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                        )
                      }
                    </div>
                  )
                }
                </>
              )
            )
          }
          {
            apiPhotosOnly || uploadsOnly || projectAssetsOnly || teamAssetsOnly ? undefined
            :
            (
              userPhotosOnly ? (
                this.getFullImageView('Uploads', isSingle, true, false, false, fullScreen)
              )
              :
              (
                <>
                <div className='photos__title-wrapper'>
                  <h5 className='photos__title no-select'>
                    Your uploads
                  <span className='photos__title__view-all' onClick={() => this.setDisplay('user-photos')}>View all</span>
                  </h5>
                  <ScrollArrow
                    loading={false}
                    scrollPosition={this.state.userScroll}
                    scrollClass={'user-uploads'}
                    parentClass={'slide-wrapper'}
                  />
                </div>
                {
                  userAssets.length ? (
                    <div 
                      className='photos__photo-previews user-uploads'
                      style={{
                        height: '200px',
                        marginBottom: ''
                      }}
                      onScroll={e => this.setScrollPos('userScroll', e, true)}
                    >
                      <div className='photos__row'>
                        {
                          userAssets.map((p, idx) => (
                            this.getPhotoContent(p, idx, null, false)
                          ))
                        }
                      </div>
                    </div>
                  )
                  :
                  (
                    <div className='photos__empty'>
                      {
                        userAssetsFetched ? (
                          <>
                            <span>No uploads</span>
                            <label className='gray'>{this.props.store.auth ? `Go ahead and upload an image`: `Create an account to upload images`}</label>
                          </>
                        )
                        :
                        (
                          <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                        )
                      }
                    </div>
                  )
                }
                </>
              )
            )
          }
          {
            uploadsOnly ? (
              this.getFullImageView('Uploads', true, true, false, false, fullScreen, true)
            )
            :
            undefined
          }
          {
            isSingle && (projectAssetsOnly && projectEmpty && !projectAssetsLoading && projectAssetsFetched && projectAssets.length) || 
            (userPhotosOnly && isEmpty && userAssets.length > 0 && !userAssetsLoading && userAssetsFetched) ? (
              <div 
                className='empty-result-wrapper end-results'
                style={{
                  paddingBottom: '0',
                  marginTop: '25px'
                }}
              >
                <span>That's it...</span>
                <label className='gray'>You've reached the end!</label>
              </div>
            ) : undefined
            
          } 
        </div>
      </div>
    )
  }

}

export default PhotoSlide

/*

              <div className='sidebar-slide__photo-empty empty-result'>
                <span>No photos</span>
                <label className='gray'>
                  Try searching for something else
                </label>
              </div>
*/